<template>
  <div class="uk-child-width-1-2@s uk-child-width-1-3@m uk-child-width-1-4@l" uk-grid>
    <div v-for="datasheet in filteredDatasheets">
      <div class="card-download card-download--scheda">
        <a :href="datasheet.path" :title="$t('frontend-cinquanta3.download_collection.download_tech_sheet')"
           class="card-download__link">
          <div class="card-download__media-wrapper">
            <div class="card-download__media" v-html="datasheet.media.thumbnail">
            </div>
          </div>
          <div class="card-download__body">
            <p class="card-download__title">{{ datasheet.title_list }} <span class="uk-text-light">- {{ datasheet.name }}</span></p>
          </div>
        </a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    datasheets: {
      type: Object,
    },
  },
  data() {
    return {
      filteredCategory: false,
      filteredDatasheets: Object,
    }
  },
  mounted() {
    this.filteredDatasheets = this.datasheets;
    this.$root.$on('select-download-filter-category', id => {
      let datasheets = [];
      Object.values(this.datasheets).forEach(function (d) {
        if(d.categories.indexOf(id.toString()) !== -1) {
          datasheets.push(d);
        }
      });
      this.filteredDatasheets = datasheets;
    });
  }
}
</script>



// WEBPACK FOOTER //
// public/themes/frontend/cinquanta3/assets/js/theme-components/DataSheets.vue